import React, { FunctionComponent } from 'react'
import { Button, Divider, Text } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import styles from './styles.module.css'
import Image from 'next/image'
import { Tile } from './Tile'
import { getImagePath } from './helper'

export interface CardEducationProps {
  onContinue?: () => void
}

export const CardEducation: FunctionComponent<CardEducationProps> = ({ onContinue }) => {
  const { t } = useTranslation(['cardEducation'])

  const cardImagePath = getImagePath(t('heroImage'))
  const exclusiveOfferImagePath = getImagePath(t('tiles.shopAnywhere.image'))
  const buriedCashAppImagePath = getImagePath(t('tiles.planYourPurchase.image'))

  const handleContinue = (): void => {
    onContinue?.()
  }

  return (
    <div className={styles.container}>
      <Image src={cardImagePath} alt={t('heroImageAlt')} width={348} height={262} data-testid='hero-image' />
      <Text size='XXL'>{t('heading')}</Text>
      <Text size='S'>{t('description')}</Text>

      <Tile
        image={exclusiveOfferImagePath}
        title={t('tiles.shopAnywhere.title')}
        description={t('tiles.shopAnywhere.description')}
        imageAlt={t('tiles.shopAnywhere.imageAlt')}
      />
      <Tile
        image={buriedCashAppImagePath}
        title={t('tiles.planYourPurchase.title')}
        description={t('tiles.planYourPurchase.description')}
        imageAlt={t('tiles.planYourPurchase.imageAlt')}
      />
      <Tile
        image={buriedCashAppImagePath}
        title={t('tiles.chooseFlexiblePlans.title')}
        description={t('tiles.chooseFlexiblePlans.description')}
        imageAlt={t('tiles.chooseFlexiblePlans.imageAlt')}
      />

      <div className={styles.footerContainer}>
        <Divider kind='Hairline' margin='Regular' />
        <Button.Primary onClick={handleContinue} padding='Fluid'>
          {t('getNewCard')}
        </Button.Primary>
      </div>
    </div>
  )
}
